'use client'

import { SWRConfig } from 'swr'
import { fetcher } from '@/lib/request'

interface ÅSWRProviderProps {
  children: React.ReactNode
}

function SWRProvider({ children }: ÅSWRProviderProps) {
  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: true,
        shouldRetryOnError: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}

export { SWRProvider as ÅSWRProvider }
